import React, { useRef, useEffect } from 'react';
import {
	Chart,
	DoughnutController,
	ArcElement,
	Tooltip,
	Legend,
} from 'chart.js';
import { Col, Row } from 'antd';

Chart.register(DoughnutController, ArcElement, Tooltip, Legend);

const HalfDonutChart = ({ data, type, colors, legends, totalValue }) => {
	const chartRef = useRef(null);

	const formatNumber = (cost) => {
		if (cost === 0) {
			return '0';
		}
		const costFloat = parseFloat(cost);
		const suffixes = ['K', 'M', 'B', 'T'];

		let formattedCost = costFloat;

		let suffix = '';
		for (const s of suffixes) {
			if (formattedCost < 1000) {
				break;
			}
			formattedCost /= 1000.0;
			suffix = s;
		}
		return `${parseFloat(formattedCost.toFixed(2))}${suffix}`;
	};

	useEffect(() => {
		const ctx = chartRef.current.getContext('2d');
		const chart = new Chart(ctx, {
			type: 'doughnut',
			data: {
				labels: legends.map((legend) => legend.text),
				datasets: [
					{
						data: data,
						backgroundColor: colors,
					},
				],
			},
			options: {
				animation: {
					animateRotate: false,
				},
				rotation: -90,
				circumference: 180,
				plugins: {
					legend: {
						display: false, // Disable the built-in legend
						labels: {
							usePointStyle: true,
							pointStyle: 'circle',
						},
					},
					tooltip: {
						enabled: true,
						callbacks: {
							label: function (context) {
								let value = context.raw || 0;
								if (type === 'cases') {
									return ` ${value}%`;
								} else if (type === 'amount') {
									return ` $${formatNumber(value)}`;
								}
							},
						},
					},
				},
				cutout: '75%',
				responsive: true,
				maintainAspectRatio: false,
			},
		});

		return () => {
			chart.destroy();
		};
	}, [data, colors]);

	// return <canvas ref={chartRef} className="half-donut-chart"></canvas>;
	return (
		<Row gutter={(15, 15)} className="half-donut-chart">
			<Col
				xs={24}
				sm={14}
				lg={14}
				xl={14}
				xxl={12}
				className="mb-4 mb-sm-0"
			>
				<canvas ref={chartRef}></canvas>
				<div className="dataCenterValue">
					<span>Total</span>
					<br />
					{totalValue}
				</div>
			</Col>
			<Col xs={24} sm={10} lg={10} xl={10} xxl={12}>
				<div className="custom-legend">
					{legends.map((legend, index) => (
						<div key={index} className="legend-item">
							<span
								className="legend-color"
								style={{
									// backgroundColor: colors[index],
									background: colors[index] || '#000', // Fallback to black if color is missing
								}}
							></span>
							<span className="legend-text">{legend.text}</span>
						</div>
					))}
				</div>
			</Col>
		</Row>
	);
};

export default HalfDonutChart;
